var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    _vm._g(
      {
        attrs: {
          width: "101",
          height: "41",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
        },
      },
      _vm.$listeners
    ),
    [
      _c(
        "g",
        {
          attrs: {
            "clip-path":
              "url(#lifehacker-logo_svg__lifehacker-logo_svg__clip0)",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M4.57 32.748H.75V8.468l3.82.246v24.034zm6.255 0h-3.82V15.43l3.82.216v17.1zm-1.91-22.586c1.202 0 2.188.986 2.188 2.188a2.196 2.196 0 01-2.188 2.188 2.196 2.196 0 01-2.188-2.188c0-1.202.986-2.188 2.188-2.188zm11.03 8.751v3.82H17.08v9.998h-3.82V13.736c0-2.896 2.403-5.515 5.237-5.515.956 0 1.726.278 1.91.4l-.153 3.667h-1.757c-.77 0-1.417.647-1.417 1.448v5.177h2.866zm5.367 3.328h2.865v-1.787c0-.802-.647-1.448-1.417-1.448a1.447 1.447 0 00-1.448 1.448v1.787zm-3.82-1.787a5.267 5.267 0 015.268-5.27c2.896 0 5.238 2.373 5.238 5.27v3.697a1.9 1.9 0 01-1.91 1.91h-4.776v1.664c0 .801.647 1.449 1.448 1.449h3.667l.123 3.235-3.451.524c-3.328.554-5.608-2.311-5.608-5.208v-7.271zm13.773 12.294V8.622h2.465v7.333c.678-.216 1.757-.308 2.496-.308 2.62 0 4.653 2.373 4.653 5.053v12.048h-2.404V20.7c0-1.325-1.078-2.372-2.403-2.372H37.73v14.42h-2.465zm18.632-4.653v-4.16h-2.373a2.354 2.354 0 00-2.372 2.373v1.787c0 1.325 1.047 2.403 2.372 2.403s2.373-1.078 2.373-2.403zm0-7.795c0-1.387-.647-2.496-2.404-2.311h.031c-.986.03-2.249.154-3.297.215-.03-.893-.061-1.232-.092-1.91.832-.308 2.034-.616 3.05-.647 3.082-.062 5.115 2.434 5.115 5.115v7.333c0 2.65-2.126 4.838-4.776 4.838s-4.837-2.188-4.837-4.838v-1.51c0-2.65 1.818-4.652 4.837-4.652 1.14 0 1.726.123 2.373.308V20.3zm9.306-4.653a4.846 4.846 0 014.838 4.838v.308c-.955.03-1.726.03-2.434.061v-.37c0-1.294-1.079-2.372-2.404-2.372-1.294 0-2.342 1.078-2.342 2.373v7.703c0 1.355 1.048 2.372 2.342 2.372s2.373-.986 2.404-2.28a78.14 78.14 0 002.434.154c-.123 2.557-2.28 4.591-4.838 4.591-2.65 0-4.807-2.157-4.807-4.837v-7.703c0-2.681 2.157-4.838 4.807-4.838zm14.55 17.1l-4.684-8.165c-.462-.8-.462-.893.093-1.848l4.128-6.84h2.804l-4.652 7.888 5.022 8.966h-2.712zm-5.3-24.064v24.065h-2.465V8.683h2.465zm10.995 14.42h4.745v-2.588c0-1.325-1.078-2.403-2.373-2.403-1.324 0-2.372 1.078-2.372 2.403v2.588zm-2.465-2.588c0-2.68 2.157-4.868 4.837-4.868 2.65 0 4.807 2.188 4.807 4.868v3.79c0 .709-.554 1.233-1.232 1.233h-5.947v2.619c0 1.325 1.048 2.403 2.373 2.403h3.112c.03.801.061 1.356.123 1.91l-2.958.463c-3.02.523-5.115-2.096-5.115-4.776v-7.642zm14.271 12.233H92.79V20.73c0-2.68 2.096-5.176 5.177-5.115 1.047.031 1.695.278 2.403.616-.031.74-.061 1.356-.092 1.91l-2.68-.06c-1.295 0-2.343 1.386-2.343 2.649v12.017z",
              fill: "#2C3143",
            },
          }),
        ]
      ),
      _c("defs", [
        _c(
          "clipPath",
          { attrs: { id: "lifehacker-logo_svg__lifehacker-logo_svg__clip0" } },
          [
            _c("path", {
              attrs: {
                fill: "#fff",
                transform: "translate(.75 .47)",
                d: "M0 0h99.84v40.308H0z",
              },
            }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }